import styled from 'styled-components';
import { FormControl, Link } from '@material-ui/core';
import { DSButton, DSLink, DSText } from '@engenharia/ds-react';

import Colors from '../../styles/theme/colors';
import spaces from '../../styles/theme/spaces';
import { devices } from '../../styles/theme/devices';
import { Hidden } from '../../components/utilities/Hidden';
import BackgroundImage from '../../assets/logo-symbol.svg';
import { forMd } from '../../config/_variables';

const Container = styled.div`
  align-items: center;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  padding: 56px 0;

  @media ${devices.laptop} {
    background-attachment: fixed;
    background-image: url(${BackgroundImage});
    background-position: -490px 160px;
    background-repeat: no-repeat;
  }
`;

const WrapperBanner = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 32px;

  @media ${devices.laptop} {
    padding: 0;
  }
`;

const Section = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 1140px;
  text-align: center;

  @media ${devices.laptop} {
    display: grid;
    grid-column-gap: ${spaces.small};
    grid-template-columns: repeat(12, 1fr);
  }
`;

const ContainerBanner = styled.div`
  padding: 0 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${forMd} {
    padding: 0;
  }
`;

const CallToActionBox = styled(Hidden)`
  grid-column: 2 / span 4;
`;

const Card = styled.div`
  align-items: center;
  background-color: ${Colors.default.white};
  display: flex;
  flex-direction: column;
  flex: 1;
  height: fit-content;
  justify-content: center;
  padding: ${spaces.medium};
  text-align: center;

  @media ${devices.laptop} {
    border-radius: 4px;
    grid-column: 7 / span 5;
    padding: ${spaces.small};
  }

  @media ${devices.tablet} {
    border: solid 1px ${Colors.default.lightGrey};
    height: auto;
  }
`;

const Image = styled.img`
  height: 48px;
  object-fit: contain;
  width: 100%;

  @media ${devices.laptop} {
    height: 147px;
  }
`;

const Divider = styled.div`
  margin: calc(${spaces.xs} / 2) 0;
  padding: 0;
  text-align: center;
`;

const DividerText = styled(DSText)`
  background-color: #fff;
  color: ${Colors.default.black87};
  font-family: 'Poppins', sans-serif;
  margin: 0;
  padding: 0 ${spaces.small};
  position: relative;
  z-index: 2;
`;

const DividerLine = styled.hr`
  border: solid 0.5px rgba(0, 0, 0, 0.12);
  margin: 0;
  padding: 0;
  position: relative;
  top: -10px;
  z-index: 1;
`;

const SignupBox = styled.div`
  margin-top: calc(${spaces.xs} / 2);
`;

const SignInFreeButton = styled(DSButton)`
  background: transparent;
  height: 36px;
  margin-bottom: ${spaces.small};
  margin-top: calc(${spaces.xs} / 2);

  @media ${devices.laptop} {
    margin-bottom: 0;
    margin-top: ${spaces.xs};
  }
`;

const LinkButton = styled(DSLink)`
  height: 36px;
  margin: 0;
`;

const CheckboxContainer = styled(FormControl)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 8px;

  & > .MuiCheckbox-root {
    padding: 0;
    color: #1a73e8;
  }

  & > p {
    color: #757575;
    letter-spacing: normal;
  }
`;

export {
  CallToActionBox,
  Card,
  Container,
  Divider,
  DividerLine,
  DividerText,
  Image,
  LinkButton,
  Section,
  SignInFreeButton,
  SignupBox,
  WrapperBanner,
  ContainerBanner,
  CheckboxContainer,
};
